export const SectionHeading = ({ eyebrow, title, intro, testid }) => (
  <div className="max-w-2xl" data-testid={testid}>
    <p className="font-caps text-[11px] text-[#D4AF37]">{eyebrow}</p>
    <h2 className="font-display text-4xl sm:text-5xl font-medium mt-4 leading-tight text-zinc-50">{title}</h2>
    <div className="w-16 h-px bg-[#D4AF37]/70 mt-6" />
    {intro && <p className="mt-6 text-sm sm:text-base text-zinc-400 leading-relaxed whitespace-pre-line">{intro}</p>}
  </div>
);
